/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Clients_Score_RecencyInputs */

const cs_clients_score_recency = /** @type {(inputs: Clients_Score_RecencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualita ${i?.n}`)
};

const en_clients_score_recency = /** @type {(inputs: Clients_Score_RecencyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recency ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Recency {n}" |
*
* @param {Clients_Score_RecencyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_score_recency = /** @type {((inputs: Clients_Score_RecencyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Score_RecencyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_score_recency(inputs)
	return cs_clients_score_recency(inputs)
});